module.exports = __webpack_public_path__ + "static/em_capabilities_3_5-dcb176bfbfd1512ca6b27093af7fcca7.png";